import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import AppProviders from './app/providers/AppProviders';
import { ErrorBoundary } from '@shared/components';
import { initializeEnv } from '@shared/config/env';
import { logger } from '@shared/utils/logger';
import '@assets/styles/index.css';

logger.debug('🚀 FULL APP: Starting complete application...');

// Catch ALL errors
window.onerror = function(msg, url, lineNo, columnNo, error) {
  logger.error('❌ GLOBAL ERROR:', msg, 'at', url, lineNo, columnNo, error);
  return false; // Let React ErrorBoundary handle it
};

try {
  logger.debug('⚙️ Initializing environment...');
  initializeEnv();
  logger.debug('✅ Environment initialized');
  
  const rootElement = document.getElementById('root');
  
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  logger.debug('🎨 Rendering full app with routing...');
  
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ErrorBoundary>
        <BrowserRouter>
          <AppProviders>
            <App />
          </AppProviders>
        </BrowserRouter>
      </ErrorBoundary>
    </React.StrictMode>
  );

  logger.debug('✅ Full app rendered!');
} catch (error) {
  logger.error('❌ App initialization FAILED:', error);
  const errorMessage = error instanceof Error ? error.message : String(error);
  const errorStack = error instanceof Error ? error.stack || '' : '';
  document.body.innerHTML = `
    <div style="padding: 20px; background: #fdd; color: #900; font-family: monospace;">
      <h1>APP INITIALIZATION FAILED!</h1>
      <pre>${errorMessage}\n\n${errorStack}</pre>
    </div>
  `;
}
